// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"ap-z","slideIn":"bp-z"};